<template>
  <div>
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="businessApplication"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div>
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商务编号">
              <el-input v-model="businessApplication.businessApplicationNO" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="制单人">
              <el-input v-model="businessApplication.creatorName" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="制单时间">
              <el-input v-model="businessApplication.createdDate" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="businessApplication.status" disabled>
                <el-option v-for="item in businessApplicationStatusList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提交时间">
              <el-input v-model="businessApplication.submitDate" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款方式" prop="payMethod">
              <el-input v-model="businessApplication.payMethod" placeholder="请输入付款方式"/>
            </el-form-item>
          </el-col>
          <!-- 可能需要修改 -->
          <el-col :span="8">
            <el-form-item label="客户" prop="customerName">
              <el-input v-model="businessApplication.customerName" readonly placeholder="请选择客户">
                <el-button slot="append" @click="$refs.selectCustomerName.open()">选择</el-button>
              </el-input>
              <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input v-model="businessApplication.contact" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式">
              <el-input v-model="businessApplication.telephone" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有效期限" prop="timeLimit">
              <el-select v-model="businessApplication.timeLimit">
                <el-option v-for="item in timeLimitList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="businessApplication.timeLimit === 20" :span="16">
            <el-form-item label="选择期限" prop="beginEndDate">
              <el-date-picker
                  v-model="businessApplication.beginEndDate"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="beginEndDateChange"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="申请理由" prop="reason">
              <el-input v-model="businessApplication.reason" type="textarea" placeholder="请输入申请理由"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注">
              <el-input v-model="businessApplication.note" type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">订单物料</div>
      <div style="margin-bottom: 10px">
        <el-button style="float: left" type="primary" @click="$refs.selectMaterial.open()"> 添加物料 </el-button>
        <el-col :span="6">
          <el-form-item label="免包装和运输费用" label-width="140px">
            <el-radio-group v-model="businessApplication.containsFee">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="!businessApplication.containsFee" :span="8">
          <el-form-item label="包装和运输费用(元)" label-width="140px" prop="packDeliveryFee">
            <el-input v-model="businessApplication.packDeliveryFee" placeholder="请输入包装和运输费用"/>
          </el-form-item>
        </el-col>
      </div>
      <el-table ref="payData" :data="priceVOS1" border="">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column align="center" prop="materialNo" label="物料编号" width="150"/>
        <el-table-column align="left" prop="materialName" label="物料名称" show-overflow-tooltip/>
        <el-table-column align="left" prop="specification" label="规格型号" show-overflow-tooltip/>
        <el-table-column align="center" prop="standardPrice" label="标准价格" width="100"/>
        <el-table-column align="center" prop="price" label="申请价格" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.price"/>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="level3FloatingPrice" label="浮价" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.level3FloatingPrice"/>
            </template>
          </el-table-column> -->
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button type="danger" @click="oneDelete(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <material-select ref="selectMaterial" @select="selectMaterial"/>
    </el-form>
    <div style="text-align: right">
      <el-button @click="cancel">取消</el-button>
      <el-button style="margin-top: 10px;" :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
  import auth from "@/util/loginUtil";
  import CustomerSelect from "../../information/Customer/CustomerSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import constant from "@/util/constant";
  export default {
    name: "BusinessApplicationAdd",
    components: { MaterialSelect, CustomerSelect },
    data() {
      return {
        businessApplicationStatusList: constant.toSelect(constant.BusinessApplicationStatus), // 状态
        timeLimitList: constant.toSelect(constant.timeLimit), // 有效期限
        contentLoading: false,
        submitLoading: false,
        files: [],
        fileList: [],
        actionUrl: window.config.basicServerUrl + "file/upload",
        sDSalesOrderVO:{},
        businessApplication: {
          businessApplicationID: 0,
          businessApplicationNO: "",
          status: 2201,
          createdDate: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          creatorName: auth.getName(),
          customerName: "",
          containsFee: true,
          attachments: [],
          priceVOS: [],
          beginEndDate: [],
        },
        priceVOS1: [],
        priceVOS2: [],
        ruleValidate: {
          payMethod: { required: true, message: "请输入付款方式", trigger: "blur" },
          customerName: { required: true, message: "请选择客户", trigger: "change" },
          timeLimit: { required: true, message: "请选择有效期限", trigger: "change" },
          beginEndDate: { type: "array", required: true, message: "请选择期限", trigger: "change" },
          reason: { required: true, message: "请输入申请理由", trigger: "blur" },
          packDeliveryFee: { required: true, message: "请输入包装和运输费用", trigger: "blur" },
        },
      };
    },
    created() {
      console.log(this.$route.query);
      this.getNo();
      this.materialList = this.$route.query.materialList ;
      this.sDSalesOrderVO = this.$route.query.sDSalesOrderVO ;
      this.initData();
      // this.billId = this.$route.query.businessApplicationID + "";
      // this.billType = this.$route.query.billType + "";
      // this.getData(this.$route.query.businessApplicationID);
    },
    // mounted() {
    //   document.getElementsByClassName("v-modal")[0].style.display = "none";
    // },

    methods: {
      // open(id) {
      //   this.businessApplication.businessApplicationID = id;
      //   if (id > 0) {
      //     this.getData();
      //   } else {
      //     this.getNo();
      //   }
      // },
      initData() {
        this.businessApplication.customerID = this.sDSalesOrderVO.customerId;
        this.businessApplication.customerName = this.sDSalesOrderVO.customerName;
        this.businessApplication.contact = this.sDSalesOrderVO.contact;
        this.businessApplication.telephone = this.sDSalesOrderVO.telephone;
        for (let item of this.materialList) {
          this.priceVOS1.push({
            materialNo: item.materialNo,
            materialName: item.materialName,
            standardPrice: item.standardPrice,
            productID: item.materialId,
            specification: item.specification,
            price: item.price,
            floatingPrice: 0,
          });
        }
      },
      // 商务编号
      getNo() {
        this.$http.get("basic", "sd/ba/getNo").then((resp) => {
          if (resp.success) {
            this.businessApplication.businessApplicationNO = resp.data;
          }
        });
      },

      // 选择客户
      selectCustomerName(row) {
        this.businessApplication.customerID = row.customerID;
        this.businessApplication.customerName = row.customerName;
        this.businessApplication.contact = row.contact;
        this.businessApplication.telephone = row.telephone;
      },

      // 自定义日期范围
      beginEndDateChange(val) {
        if(val) {
          this.$set(this.businessApplication, "beginEndDate", val);
          this.businessApplication.beginDate = val[0];
          this.businessApplication.endDate = val[1];
        }
      },

      // 选择物料
      selectMaterial(row) {
        console.log("物料信息",row);
        var result = this.priceVOS1.find((item) => item.productID === row.materialID);
        if (result) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.priceVOS1.push({
          materialNo: row.materialNO,
          materialName: row.materialName,
          standardPrice: row.standardPrice,
          productID: row.materialID,
          price: row.level3Price,
          floatingPrice: row.level3FloatingPrice,
        });
      },

      //删除物料
      oneDelete(index) {
        this.priceVOS1.splice(index, 1);
      },

      // 根据id查询详情
      getData() {
        this.$http.get("basic", `sd/ba/${this.businessApplication.businessApplicationID}/0`).then((resp) => {
          if (resp.success) {
            this.businessApplication = resp.data;
            console.log(this.businessApplication);
            this.priceVOS1 = this.businessApplication.priceVOS;
            if (this.businessApplication.beginDate && this.businessApplication.endDate) {
              this.businessApplication.beginEndDate = [this.businessApplication.beginDate, this.businessApplication.endDate];
            }
          }
        });
      },

      // 上传成功
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.businessApplication.attachments.push(params);
        }
      },

      //删除附件
      oneDelete2(index) {
        this.businessApplication.attachments.splice(index, 1);
      },
      cancel() {
        // 关闭标签
        this.$bus.$emit("closeTag", this.$route);
      },
      // 提交
      handleSubmit() {
        this.businessApplication.priceVOS = this.priceVOS1;
        console.log(this.businessApplication);
        this.submitLoading = true;
        this.$http.post("basic", "sd/ba/insertPriceApply", this.businessApplication).then((resp) => {
          if (resp.success) {
            this.$message.success("添加成功");
            this.$bus.$emit("closeTag", this.$route);
          }
          this.submitLoading = false;
        });
      },
    },
  };
</script>